import bFormInput from './form-input.vue';

export default bFormInput;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-input/form-input.js
// module id = 386
// module chunks = 1